import { parseNumberFromString } from '@ori/presentation-utils';
export const getCurrentFormattedPrice = ({
  formattedPrice
}) => {
  const {
    currentPrice,
    priceAfterImmediateDiscount
  } = formattedPrice?.price ?? {};
  if (priceAfterImmediateDiscount && parseNumberFromString(priceAfterImmediateDiscount) > 0) {
    return priceAfterImmediateDiscount;
  }
  return currentPrice ?? '';
};
//# sourceMappingURL=getCurrentFormattedPrice.js.map